import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { DxButtonModule, DxToastModule } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';
import { Task } from '../task';
import { UserAvatarComponent } from '../user-avatar/user-avatar.component';

@Component({
  selector: 'dk-task-kanban-card',
  templateUrl: './task-kanban-card.component.html',
  styleUrls: ['./task-kanban-card.component.scss'],
  standalone: true,
  imports: [DxButtonModule, DxToastModule, CommonModule, UserAvatarComponent],
})
export class TaskKanbanCardComponent {
  @Input() task: Task;

  constructor(private router: Router) {}

  getAvatarText = (name: string) =>
    name
      .split(' ')
      .map((name) => name[0])
      .join('');

  notify = (e: any) => {
    e.event.stopPropagation();
    notify(`Edit '${this.task.text}' card event`);
  };

  navigateToDetails = () => {
    this.router.navigate(['/main/task/detail']);
  };
}
